export function relativeDate(date: Date): string {
  const now = new Date();
  const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (seconds < 60) return "Just now";

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;

  const calendar = new Intl.DateTimeFormat("en-US", { weekday: "long" });
  const days = Math.floor(hours / 24);

  if (days === 1) return "Yesterday";
  if (days < 7) return calendar.format(date);

  return formatShortDate(date, now.getFullYear() !== date.getFullYear());
}

export function dueDate(date: Date): string {
  const now = new Date();
  const today = startOfDay(now);
  const target = startOfDay(date);
  const diffDays = Math.floor((target.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));

  if (diffDays < 0) return "Overdue";
  if (diffDays === 0) return "Due today";
  if (diffDays === 1) return "Due tomorrow";
  if (diffDays <= 6) {
    const weekday = new Intl.DateTimeFormat("en-US", { weekday: "long" }).format(date);
    return `Due ${weekday}`;
  }

  return `Due ${formatShortDate(date, now.getFullYear() !== date.getFullYear())}`;
}

function startOfDay(date: Date): Date {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

function formatShortDate(date: Date, includeYear: boolean): string {
  const options: Intl.DateTimeFormatOptions = { month: "short", day: "numeric" };
  if (includeYear) options.year = "numeric";
  return new Intl.DateTimeFormat("en-US", options).format(date);
}
